import MainLayout from "@/components/layout/admin/MainLayout.vue";
import $ from "jquery";
import DatePicker from "vue2-datepicker";
import NrcNameJson from "@/assets/json/nrc_list.json";
import NaingJson from "@/assets/json/naing.json";
import RegionJson from "@/assets/json/region.json";
import {
    required,
    email,
    minLength,
    maxLength,
    numeric
} from 'vuelidate/lib/validators';
import {
    ConvertNumService
} from "@/assets/js/convertNumberService.js";
import axios from "axios";

const convertNumberService = new ConvertNumService();

export default {
    name: "adminResumeUpdate",
    components: {
        MainLayout,
        DatePicker,
    },

    data() {
        return {
            resume: {
                id: "",
                applicant_id:"",
                name: "",
                nrc_number: "",
                profile_image: "",
                nationality: "",
                religion: "",
                date_of_birth: "",
                email: "",
                facebook: "",
                linkin: "",
                gender: 1,
                marital_status: 2,
                contact_address: "",
                permanent_address: "",
                experience_detail: "",
                education_detail: "",
                other_certificate: "",
                position: "",
                expected_salary: "",
            },
            nrcno: [{
                    value: "1",
                    name: "၁"
                },
                {
                    value: "2",
                    name: "၂"
                },
                {
                    value: "3",
                    name: "၃"
                },
                {
                    value: "4",
                    name: "၄"
                },
                {
                    value: "5",
                    name: "၅"
                },
                {
                    value: "6",
                    name: "၆"
                },
                {
                    value: "7",
                    name: "၇"
                },
                {
                    value: "8",
                    name: "၈"
                },
                {
                    value: "9",
                    name: "၉"
                },
                {
                    value: "10",
                    name: "၁၀"
                },
                {
                    value: "11",
                    name: "၁၁"
                },
                {
                    value: "12",
                    name: "၁၂"
                },
                {
                    value: "13",
                    name: "၁၃"
                },
                {
                    value: "14",
                    name: "၁၄"
                }
            ],
            submitted: false,
            profile_image: "",
            nrcNameJson: NrcNameJson,
            naingJson: NaingJson,
            regionArr: RegionJson,
            nrckey: "",
            selectedNrcName: "",
            selectedNrcNaing: "",
            districtList: [],
            naingList: [],
            nrcName: []
        };
    },

    validations: {
        resume: {
            name: {
                required,
                maxLength: maxLength(100)
            },
            nrc_number: {
                required,
                minLength: minLength(6),
                maxLength: maxLength(6)
            },
            nationality: {
                required,
                maxLength: maxLength(100)
            },
            religion: {
                required
            },
            date_of_birth: {
                required
            },
            email: {
                required,
                email
            },
            phone_number: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(11),
                numeric
            },
            gender: {
                required
            },
            marital_status: {
                required
            },
            contact_address: {
                required,
                maxLength: maxLength(200)
            },
            education_detail: {
                required
            },
            position: {
                required
            },
            expected_salary: {
                numeric
            },
        }
    },

    methods: {
        onProfileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return null;
            this.resume.profile_image = e.target.files[0];
            let reader = new FileReader();
            reader.onload = (e) => {
                this.profile_image = e.target.result;
            };
            reader.readAsDataURL(files[0]);
            if (this.resume.profile_image.length != 0 || this.profile_image.length != 0) {
                $('.remove-btn').addClass('img_remove_btn_show');
            }
        },

        imgRemove() {
            document.getElementById('profile-pic-user').src = require('@/assets/images/dashboard/resume_profile.png');
            document.getElementById('file_input').value = null;
            $('#profile-pic-user').removeClass('profile-img');
            this.profile_image = require('@/assets/images/dashboard/resume_profile.png');
            this.profile_image = '';
            this.resume.profile_image = '';
            $('.remove-btn').removeClass('img_remove_btn_show');
            $('.remove-btn').addClass('img_remove_btn');
        },

        onChange(event) {
            var optionValue = event.target.value;
            var optionText = event.target.options[event.target.options.selectedIndex].text;
            if (optionValue) {
                this.nrckey = optionText;
            } else {
                this.nrckey = optionValue;
            }
            this.selectedNrcName = "";
            this.districtList = this.changeNrcName(optionValue);
        },

        changeNrcName(value, nrcName) {
            nrcName = this.nrcNameJson[value - 1];
            return nrcName;
        },

        onChangeNrcName() {
            this.naingList = this.naingJson;
        },

        getResume() {
            axios.get("/applicant/resume/detail/" + this.$route.params.id)
                .then(response => {
                    this.resume = response.data;
                    if (response.data.nrc_number) {
                        var nrcfirst = response.data.nrc_number.split('/');
                        var nrcsecond = nrcfirst[1].split('(');
                        var nrcthird = nrcsecond[1].split(')');
                        this.nrckey = convertNumberService.convertMm2Eng(nrcfirst[0]);
                        this.selectedNrcName = nrcsecond[0];
                        this.districtList = this.changeNrcName(this.nrckey);
                        this.naingList = this.naingJson;
                        this.selectedNrcNaing = '(' + nrcthird[0] + ')';
                        this.resume.nrc_number = nrcthird[1];
                    }
                    if (response.data.profile_image == null) {
                        $('.remove-btn').addClass('img_remove_btn');
                    }
                })
                .catch(error => {
                    console.log("Resume Detail API error:::::>", error.response.data);
                });
        },

        submitUpdate() {
            this.submitted = true;
            if (this.$v.resume.$invalid) {
                // console.log(this.$v.resume);
                console.log('resume update validation error');
            } else {
                this.updateResume();
            }
        },

        updateResume() {
            var nrc = '';
            if (this.nrckey &&
                this.selectedNrcName &&
                this.selectedNrcNaing &&
                this.resume.nrc_number) {
                nrc = convertNumberService.convertEng2Mm(this.nrckey)
                    .concat('/')
                    .concat(this.selectedNrcName)
                    .concat(this.selectedNrcNaing)
                    .concat(convertNumberService.convertEng2Mm(this.resume.nrc_number));
            }
            const data = new FormData();
            data.append('id', this.resume.id);
            data.append('name', this.resume.name);
            data.append('nrc_number', nrc);
            // data.append('profile_image', this.profile_image);
            // data.append('oldprofile_image', this.resume.profile_image);
            data.append('nationality', this.resume.nationality);
            data.append('religion', this.resume.religion);
            data.append('date_of_birth', this.resume.date_of_birth);
            data.append('phone_number', this.resume.phone_number);
            data.append('email', this.resume.email);
            data.append('facebook', this.resume.facebook);
            data.append('linkin', this.resume.linkin);
            data.append('gender', this.resume.gender);
            data.append('marital_status', this.resume.marital_status);
            data.append('contact_address', this.resume.contact_address);
            data.append('permanent_address', this.resume.permanent_address);
            data.append('education_detail', this.resume.education_detail);
            data.append('other_certificate', this.resume.other_certificate);
            data.append('experience_detail', this.resume.experience_detail);
            data.append('expected_salary', this.resume.expected_salary);
            data.append('position', this.resume.position);

            if (this.profile_image == '' && this.resume.profile_image != '') {
                data.append('oldprofile_image', this.resume.profile_image);
            } else if (this.profile_image.length != 0 && this.profile_image.length < 10000000) {
                data.append('profile_image', this.profile_image);
            } else if (this.profile_image.length != 0 && this.profile_image.length > 10000000) {
                data.append('profile_image', 'large-img');
            } else {
                data.append('profile_image', '');
            }

            axios.post("/applicant/resume/update", data)
                .then(response => {
                    if (response.data.img_error_msg) {
                        this.image_size = response.data.msg;
                        this.isLoading = false;
                        this.$notification.error("The upload image size is too large.", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    } else {
                        this.$notification.success("Resume Edited Successfully", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                        this.$router.push({
                            path: "/admin/applicant/detail/" + this.resume.applicant_id
                        });
                    }
                })
                .catch(error => {
                    this.$notification.error("Resume Edit Failed", {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    console.log('Vue Update Post Failed', error)
                });
        }
    },

    mounted() {
        this.getResume();

        $("#nrc_number").on("keypress keyup blur", function (event) {
            $(this).val($(this).val().replace(/[^\d].+/, ""));
            if ((event.which < 48 || event.which > 57)) {
                event.preventDefault();
            }
        });

        $("#expected_salary").on("keypress keyup blur", function (event) {
            $(this).val($(this).val().replace(/[^\d].+/, ""));
            if ((event.which < 48 || event.which > 57)) {
                event.preventDefault();
            }
        });
    }
};